import { useEffect } from "react";

const CGOLD_URL = "https://cgold.ae/";

function App() {
  useEffect(() => {
    window.location.replace(CGOLD_URL);
  }, []);

  return (
    <></>
  );
}

export default App;
